import { useMemo } from 'react';
import { useMonitoringTrailing } from '../../../hooks/useMonitoringTrailing';
import { GranularityToggle } from '../../accounts/GranularityToggle';
import { OverviewCard } from '../../billing/overview/OverviewCard';
import { OverTimeBody } from './OverTimeCardParts';
import { BUCKET_OPTIONS, bucketWindow } from './overTimeRows';
import { useStoredChoice } from './useStoredChoice';
import { buildVaFlowChart } from './vaFlowRows';

const BUCKET_STORAGE_KEY = 'monitoring_overview_va_flow_bucket';
const INFO =
    'Due: a planned VA was triggered, or a VA was created already open. Treated: a VA was marked done.';

export function VaFlowCard() {
    const [bucket, setBucket] = useStoredChoice(BUCKET_STORAGE_KEY, BUCKET_OPTIONS);
    const flow = useMonitoringTrailing('virtual-appointments/flow', bucket);
    const chart = useMemo(() => (flow.data ? buildVaFlowChart(flow.data) : null), [flow.data]);
    // Labels follow the bucket the data is for, so the previous bucket never wears the new name.
    const period = bucketWindow(flow.data?.bucket ?? bucket);
    return (
        <OverviewCard
            title="Virtual appointments"
            titleClassName="text-[15px]"
            info={INFO}
            wrapAction
            action={
                <GranularityToggle
                    value={bucket}
                    options={BUCKET_OPTIONS}
                    onChange={setBucket}
                    ariaLabel="Virtual appointments: day, week or month"
                />
            }
        >
            <OverTimeBody
                chart={chart}
                isLoading={flow.isLoading}
                isSwitching={flow.isSwitching}
                errorMessage={flow.isError ? "Couldn't load virtual appointments" : null}
                emptyMessage={`No VAs due or treated ${period.phrase}`}
                onRetry={() => void flow.retry()}
            />
        </OverviewCard>
    );
}
